import VxePulldownComponent from './src/pulldown';
import { dynamicApp } from '../dynamics';
export var VxePulldown = Object.assign(VxePulldownComponent, {
    install: function (app) {
        app.component(VxePulldownComponent.name, VxePulldownComponent);
    }
});
export var Pulldown = VxePulldown;
dynamicApp.component(VxePulldownComponent.name, VxePulldownComponent);
export default VxePulldown;
